<template>
  <div>
    <regatta-table
      v-if="isRegattaVisible"
      :regatta="regatta"
    />

    <p v-if="message !== null">
      {{ message }}
    </p>

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../../http-common.js';
import notifier from '../../notifier.js';

import LoadingIndicator from '../LoadingIndicator.vue';
import RegattaTable from './RegattaTable.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'RegattaInfo',

  components: {
    LoadingIndicator,
    RegattaTable,
  },

  props: {
    regattaId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,
      regatta: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(this.isLoadedNormal && this.regatta === null) {
        return `Регата с идентификатором ${this.regattaId} не существует.`;
      }
      return null;
    },

    /** @returns {boolean} */
    isRegattaVisible() {
      return this.isLoadedNormal && (this.regatta !== null);
    },
  },

  created() {
    this.loadRegatta();
  },

  methods: {
    loadRegatta() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const regattaIdStr = this.regattaId.toString();
      const url = '/regatta/' + regattaIdStr;

      HTTP.get(url)
      .then(response => {
        this.regatta = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
}
</script>
